module.exports = __webpack_public_path__ + "img/Icon-83.5@2x.e332ee61.png";